"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSalesIntegrationsMessage = exports.openCustomPreview = exports.setSubjectError = exports.setTextError = exports.setMessageDraft = exports.updateMessageFail = exports.updateMessageSuccess = exports.updateMessage = exports.setShadowText = exports.setText = exports.setShadowSubject = exports.setSubject = exports.setTemplateMessage = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/GIFT/MESSAGE';
var setTemplateMessage = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_TEMPLATE_MESSAGE"));
exports.setTemplateMessage = setTemplateMessage;
var setSubject = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_SUBJECT"));
exports.setSubject = setSubject;
var setShadowSubject = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_SHADOW_SUBJECT"));
exports.setShadowSubject = setShadowSubject;
var setText = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_TEXT"));
exports.setText = setText;
var setShadowText = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_SHADOW_TEXT"));
exports.setShadowText = setShadowText;
var updateMessage = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_MESSAGE"), function (_ref) {
  var _ref$isDraft = _ref.isDraft,
      isDraft = _ref$isDraft === void 0 ? true : _ref$isDraft;
  return {
    isDraft
  };
}, function (_ref2) {
  var giftId = _ref2.giftId,
      _ref2$previewUrl = _ref2.previewUrl,
      previewUrl = _ref2$previewUrl === void 0 ? null : _ref2$previewUrl,
      _ref2$sidebarMode = _ref2.sidebarMode,
      sidebarMode = _ref2$sidebarMode === void 0 ? true : _ref2$sidebarMode;
  return {
    giftId,
    previewUrl,
    sidebarMode
  };
});
exports.updateMessage = updateMessage;
var updateMessageSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_MESSAGE_SUCCESS"));
exports.updateMessageSuccess = updateMessageSuccess;
var updateMessageFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_MESSAGE_FAIL"));
exports.updateMessageFail = updateMessageFail;
var setMessageDraft = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_MESSAGE_DRAFT"));
exports.setMessageDraft = setMessageDraft;
var setTextError = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_TEXT_ERROR"));
exports.setTextError = setTextError;
var setSubjectError = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_SUBJECT_ERROR"));
exports.setSubjectError = setSubjectError;
var openCustomPreview = (0, _reduxAct.createAction)("".concat(PREFIX, "/OPEN_CUSTOM_PREVIEW"));
exports.openCustomPreview = openCustomPreview;
var resetSalesIntegrationsMessage = (0, _reduxAct.createAction)("".concat(PREFIX, "/SALES/RESET_MESSAGE"));
exports.resetSalesIntegrationsMessage = resetSalesIntegrationsMessage;